import React, { useState, useEffect } from "react";
import searchIcon from "src/assets/i_search.svg";

interface SearchBoxProps {
        onSearch: (query: string) => void;
    }

const SearchBox: React.FC<SearchBoxProps> = ({ onSearch  }) => {
    const [searchTerm, setSearchTerm] = useState("");

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    const handleSearch = () => {
        if (searchTerm.trim() !== "") {
        onSearch(searchTerm);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
          handleSearch();
        }
      };
    useEffect(() => {
        if (searchTerm.trim() !== "") {
            onSearch(searchTerm);
        }
    }, [searchTerm]);

    return (
        <div className="mb-5">
            <h2 className="fw-bold mb-3">종목 검색</h2>
            <div className="mx-auto">
                <div className="input-group position-relative">
                <input
                    type="text"
                    className="form-control bg-gray2"
                    placeholder="종목명, 코드번호"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                />
                    <button
                        className="btn position-absolute"
                        style={{ right: 0, top: "50%", transform: "translateY(-50%)", zIndex: 2 }}
                        onClick={handleSearch}
                    >
                        <i>
                            <img src={searchIcon} alt="" />
                        </i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchBox;
